export default {
  togglePoiVisibility(state, type) {
    state.poiVisibility[type] = !state.poiVisibility[type];
  },
  updateDuplicatingState(state, data) {
    state.isDuplicating = data;
  },
  buildFilters(state, filters) {
    state.ruleFilters = filters;
    const newFilters = {};
    for (const filter in filters) {
      newFilters[filter] = [];
    }
    state.filters = newFilters;
  },
  updateIsochrone(state, payload, isPrivate) {
    if (isPrivate) {
      state.isochronePrivate = payload;
      state.isochroneMode = 'private';
    } else {
      state.isochronePublic = payload;
      state.isochroneMode = 'public';
    }
    state.isochrone = payload;
  },
  updateIsochroneDecay(state, payload) {
    state.isochroneDecay = payload;
  },
  updateIsochroneDisplay(state, payload) {
    state.isochroneDisplay = payload;
  },
  updateIsochroneMode(state, mode) {
    state.isochroneMode = mode;
    if (mode === 'public') {
      state.isochrone = state.isochronePublic;
    } else if (mode === 'private') {
      state.isochrone = state.isochronePrivate;
    }
  },
  updateRawStudy(state, payload) {
    state.rawStudy = payload;
  },
  updateActiveAside(state, { aside }) {
    state.activeAside = aside;
  },
  updateStudy(state, { study }) {
    if (study) {
      study.name = study.name.replace('_draft', '');
    }
    state.study = study;
  },
  updateSites(state, sites) {
    for (const site of sites) {
      const index = state.study.sites.findIndex(el => el.id === site.id);
      if (index >= 0) {
        state.study.sites[index] = site;
      }
    }
  },
  updateStudies(state, { studies }) {
    state.studies = studies;
  },
  updateStudyLoaded(state, status) {
    state.studyLoaded = status;
  },
  updateIndex(state, index) {
    state.activeIndex = index;
  },
  updateAllFilters(state) {
    const newFilters = {};
    for (const filter in state.ruleFilters) {
      if (state.ruleFilters[filter].length > 1) {
        newFilters[filter] = [];
      }
    }

    state.filters = newFilters;
  },
  updateFilters(state, data) {
    state.filters[data.key] = data.value;
  },
  updateGlobalFilters(state, data) {
    state.globalFilters[data.key] = data.value;
  },
  updateFetchingState(state, data) {
    state.isFetching = data;
  },
  updateCurrentModal(state, data) {
    state.currentModal = data;
  },
  togglePublicTransportLines(state) {
    state.publicTransportLinesShown = !state.publicTransportLinesShown;
  },
  toggleAirQualityIndexOverlay(state) {
    state.airQualityIndexOverlayShown = !state.airQualityIndexOverlayShown;
  },
  updateTutorial(state, data) {
    if (data) {
      localStorage.setItem('tutorial', '1');
    } else {
      localStorage.removeItem('tutorial');
    }
    state.tutorial = data;
  },
  updateMaximumTravelTime(state, study) {
    state.study.maximum_travel_time_enabled = study.maximum_travel_time_enabled;
    state.study.public_maximum_travel_time = study.public_maximum_travel_time;
    state.study.private_maximum_travel_time = study.private_maximum_travel_time;
    state.study.bicycle_maximum_travel_time = study.bicycle_maximum_travel_time;
    state.study.walking_maximum_travel_time = study.walking_maximum_travel_time;
  },
};
